<template>
  <div class="wapper">
    <div class="query-wapper">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input placeholder="方案名称" v-model="query.planName"></el-input>
        </el-col>
        <el-col :span="6">
          <el-select placeholder="状态" v-model="query.state" style="width:100%;">
            <el-option v-for="item in states" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-select placeholder="提成计算方式" v-model="query.conditionMethod" style="width:100%;">
            <el-option v-for="item in conditionMethods" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-input placeholder="创建人" v-model="query.creatorName"></el-input>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input placeholder="最后修改人" v-model="query.operatorName"></el-input>
        </el-col>
      </el-row>
      <div class="button-wapper">
        <el-button plain @click="getInfoList(undefined)">查询</el-button>
        <el-button plain @click="reset">重置</el-button>
        <el-button plain @click="add" type="primary" v-auth="'edit'">新增</el-button>
      </div>
    </div>
    <div class="content-wapper">
      <el-table :data="infos" size='mini' empty-text :border="true">
        <el-table-column prop="id" label="方案标识"></el-table-column>
        <el-table-column prop="planName" label="方案名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="conditionMethodName" label="提成计算方式" show-overflow-tooltip></el-table-column>
        <el-table-column prop="creatorName" label="创建人"></el-table-column>
        <el-table-column prop="gmtCreate" label="创建时间"></el-table-column>
        <el-table-column prop="operatorName" label="最后修改人"></el-table-column>
        <el-table-column prop="gmtModified" label="最后修改时间" show-overflow-tooltip></el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <el-switch v-auth="'edit'" v-model="scope.row.state" @change="planStateUpdate(scope.row)" :active-value="1"
              :inactive-value="2" active-color="#13ce66" inactive-color="#ff4949">
            </el-switch>
            <span v-auth-reverse="'edit'">
              {{ scope.row.stateName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="170">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row)" type="text" size="small" v-auth="'edit'">编辑</el-button>
            <el-button @click="getDetail(scope.row)" type="text" size="small">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <br>
      <el-pagination :current-page.sync="query.pageIndex" :page-size="query.pageSize"
        @current-change="handleCurrentChange" class="pagation" layout="prev, pager, next, jumper" :total="query.total">
      </el-pagination>
    </div>
    <!-- 添加合约公司 -->
    <addInvoiceCompany ref="addInvoiceCompany" @refresh="getInfoList"></addInvoiceCompany>
  </div>
</template>

<script>
import _royaltyPlan from '@/service/royalty-plan-service'
import _constant from '@/utils/constant'
import addInvoiceCompany from '@/views/invoice/company/add-invoice-company'
import _welfare from '@/service/welfare-service'

export default {
  components: {
    addInvoiceCompany
  },
  data() {
    return {
      infos: null,
      states: null,
      standards: null,
      storedTypes: null,
      conditionMethods: [
        {
          id: 1,
          name: '条件区间'
        },
        {
          id: 2,
          name: '条件选项'
        }
      ],
      query: {
        planName: null,
        state: null,
        conditionMethod: null,
        creatorName: null,
        operatorName: null,
        pageIndex: 1,
        pageSize: 20,
        total: 0,
        businessType:2, //2:积分方案
      }
    }
  },
  mounted() {
    var params = this.$getParams()
    if (params != null) {
      this.query = params
      this.getInfoList(this.query.pageIndex)
    } else {
      this.getInfoList()
    }
    // 状态
    this.states = _constant.states
    // 查询是否标准
    this.standards = _constant.standardList

    this.storedTypes = _constant.storedTypes
  },
  methods: {
    getInfoList(pageIndex) {
      if (pageIndex)
        this.query.pageIndex = pageIndex
      else
        this.query.pageIndex = 1
      _royaltyPlan.queryPlanList(
        this.query,
        (response, total) => {
          // 请求成功
          this.infos = response
          this.query.total = total
        })
    },
    handleCurrentChange(pageIndex) {
      this.getInfoList(pageIndex)
    },
    add() {
      this.$router.push({
        path: '/add-points-plan'
      })
    },
    getDetail(row) {
      this.$saveParams(this.query)
      this.$router.push({
        path: '/points-plan-detail?id=' + row.id
      })
    },
    edit(row) {
      this.$saveParams(this.query)
      this.$router.push({
        path: '/add-points-plan',
        query: {
          id: row.id,
        }
      })
    },
    reset() {
      this.query = {
        planName: null,
        state: null,
        conditionMethod: null,
        creatorName: null,
        operatorName: null,
        pageIndex: 1,
        pageSize: 20,
        total: 0,
        businessType:2,
      }
      this.getInfoList()
    },
    planStateUpdate(rows) {
      _royaltyPlan.planStateUpdate(rows.id, rows.state, () => {
        this.$notify({
          message: '修改成功',
          type: 'success'
        });
      })
    }
  }
}
</script>

<style scoped>
.wapper {
  padding: 15px;
}

.header {
  margin-bottom: 15px;
}

.query-wapper {
  margin: 15px;
  padding: 15px;
  border: 1px solid #d6dbe5;
  position: relative;
  background: #fff;
}

.query-wapper::after {
  position: absolute;
  content: '筛选条件';
  top: -9px;
  color: #909399;
  background-color: #fbfbfb;
}

.content-wapper {
  padding: 0 15px;
  padding-bottom: 30px;
}

.button-wapper {
  margin-top: 10px;
}

.el-row {
  margin-bottom: 15px;
}
</style>